export default {
  name: "E808DTriangle",
  props: {
    colors: {
      type: String,
      default: 'RGBBGR'
    }
  },
  methods: {
    init() {}
  },
  data() {
    return {
      color: {
        'R': 'red',
        'G': 'green',
        'B': 'blue',
        'Y': 'yellow',
        'X': 'black'
      }
    };
  },
  mounted() {
    this.init();
  }
};